import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-copyright',
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CopyrightComponent {
  public startYear: string;
  public currentYear: string;

  constructor() {
    this.startYear = '2010';
    this.currentYear = new Date().getFullYear().toString();
  }
}
